<ng-container *ngIf="card$ | async as memberCard">
  <div class="member-info text-white bg-primary">
    <div *ngIf="memberDetails$ | async as memberDetails">
      <div class="member-name font-heading text-uppercase font-size-14">
        {{ memberDetails?.FirstName }} {{ memberDetails?.Surname }}
      </div>
      <div class="font-size-12">{{ 'member.id' | translate }} {{ memberCard.ExternalRefNumber }}</div>
    </div>

    <div
      class="qr-code-card bg-glass d-flex flex-column align-items-center justify-content-center"
      *ngIf="(barcode$ | async)?.Barcode as barcode; else qrLoading"
    >
      <div class="qr-code-wrapper bg-white">
        <qrcode [qrdata]="barcode" [size]="120" [level]="'M'" [usesvg]="true"></qrcode>
      </div>
      <span class="font-size-12 text-white text-center mt-3">
        {{ 'barcode.description' | translate : { fgbdefault: 'Scan Member Barcode' } }}
      </span>
    </div>

    <ng-template #qrLoading>
      <div class="qr-code-card bg-glass d-flex align-items-center justify-content-center">
        <fgbcl-loading></fgbcl-loading>
      </div>
    </ng-template>

    <!-- STH: full-width single pill -->
    <ng-container *inPopulation="['STH']">
      <div class="member-points-sth bg-glass d-flex align-items-center justify-content-between w-100">
        <span class="fw-normal font-size-12 text-white">{{ 'mobile.nav.menu.points.label' | translate }}</span>
        <div class="d-flex align-items-center gap-2">
          <span class="material-symbols-outlined text-white member-pill-icon">loyalty</span>
          <span class="font-heading font-size-18 text-white text-uppercase">
            {{ pointsBalance$ | async | number : '1.0-0' : 'en-GB' }}
          </span>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between w-100 py-1">
        <span class="font-size-14 text-white">{{ 'barcode.cash.assist' | translate : { fgbdefault: 'Cash Assist' } }}</span>
        <span class="font-heading font-size-20 text-white text-uppercase">{{ cashBack$ | async | FortressCurrencyPipe }}</span>
      </div>
    </ng-container>

    <!-- Employees: full-width single pill (ecash only) -->
    <ng-container *inPopulation="['Employee']">
      <div class="member-points-sth bg-glass d-flex align-items-center justify-content-between w-100">
        <span class="fw-normal font-size-12 text-white">{{ 'barcode.credit' | translate }}</span>
        <div class="d-flex align-items-center gap-2">
          <span class="material-symbols-outlined text-white member-pill-icon">money_bag</span>
          <span class="font-heading font-size-18 text-white text-uppercase">
            {{ virtualEcash$ | async | FortressCurrencyPipe }}
          </span>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
